import Papa from "papaparse";
import { fetchCSV } from "../utils/dataCache";
import { CDN } from "../config/cdn";

export const cleanField = (value) => value == null || ["\\N", "null", "N/A"].includes(String(value).trim()) ? "" : String(value).trim();
export const normalizeSearch = (value) => String(value || "").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
export const exactName = (value) => String(value || "").trim().toLowerCase();
export const catalogId = (name) => `game:${name}`;
export const artworkFallback = `${process.env.PUBLIC_URL}/redesign/logos/icon/mindGAME Tree Logo.png`;
let catalogPromise;

export function loadResearchCatalog() {
  if (!catalogPromise) catalogPromise = fetchCSV(`${CDN.mindshare}/metadata.csv.gz`, { ttl: 600000 }).then((text) => {
    const records = Papa.parse(text, { header: true, skipEmptyLines: true }).data;
    const names = new Map();
    records.forEach((row) => { const name = cleanField(row.Game); if (name) names.set(name, (names.get(name) || 0) + 1); });
    return records.filter((row) => cleanField(row.Game) && names.get(cleanField(row.Game)) === 1).map((row) => {
      const name = cleanField(row.Game);
      return { id: catalogId(name), name, searchName: normalizeSearch(name), image: cleanField(row.ImageURL) || artworkFallback, publisher: cleanField(row.Publisher), developer: cleanField(row.Developer), genre: cleanField(row.Genre), release: cleanField(row.Release_Date), status: cleanField(row.Released_Unreleased), description: cleanField(row.Description), platforms: ["PlayStation_5", "PlayStation_4", "Xbox_Series_S_X", "Xbox_One", "Switch", "Switch_2", "PC", "Mobile"].filter((key) => cleanField(row[key])).map((key) => key.replace(/_/g, " ")), steamId: /^\d+$/.test(cleanField(row.Steam_ID)) ? cleanField(row.Steam_ID) : null, raw: row };
    });
  }).catch((error) => { catalogPromise = null; throw error; });
  return catalogPromise;
}

export function searchResearchCatalog(catalog, query, limit = 12) {
  const term = normalizeSearch(query);
  if (!term) return [];
  const words = term.split(" ");
  return catalog.filter((game) => words.every((word) => game.searchName.includes(word))).sort((first, second) => {
    const score = (game) => game.searchName === term ? 0 : game.searchName.startsWith(term) ? 1 : 2;
    return score(first) - score(second) || first.name.localeCompare(second.name);
  }).slice(0, limit);
}